export default "__VITE_ASSET__63y$pWXp__"